import { createSlice } from "@reduxjs/toolkit";
import currencyService from "../../../../services/currency/CurrencyService";




export const currencySlice = createSlice({
    name: "currency",
    initialState: {
        currencies: [],
        count: 0,
        filterOptions: {
            page: 1,
            limit: 10,
        },
    },
    reducers: {
        updateCurrency: (state, action) => {
            state.currencies = action.payload
        },
        updateCurrencyCount: (state, action) => {
            state.count = action.payload
        },
        updateFilterOptions: (state, action) => {
            state.filterOptions = action.payload
        },
    }
})

export const changeFilterOptionsAsync = ({...params}) => dispatch => {
    dispatch(currencySlice.actions.updateFilterOptions({...params}))
}



export const getCurrenciesAsync = ({page, limit, ...filters}) => dispatch => {
    const skip = (page - 1) * limit
    const params = {skip, limit, ...filters}
    
    return new Promise((resolve, reject) => {
        currencyService.currencies(params)
            .then((response) => {
                dispatch(currencySlice.actions.updateCurrency(response.data))
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const getCurrenciesCountAsync = (params) => dispatch => {
    let { limit, page, ...filters} = params

    return new Promise((resolve, reject) => {
        currencyService.currencyCount(filters)
            .then((response) => {
                dispatch(currencySlice.actions.updateCurrencyCount(response.data))
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const currencyRegisterAsync = (payload) => {
    return new Promise((resolve, reject) => {
        currencyService.currencyRegister(payload)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const currencyUpdateAsync = ({id, amount}) => {
    return new Promise((resolve, reject) => {
        currencyService.currencyUpdateRate({id, amount})
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const currencyConvertAsync = (payload) => {
    return new Promise((resolve, reject) => {
        currencyService.currencyConverter(payload)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}


export const selectCurrencyFilterOptions = state => state.currency.filterOptions
export const selectCurrencyCount = state => state.currency.count
export const selectCurrencies = state => state.currency.currencies



export default currencySlice.reducer;